/**
 * For the one error class with NO stack, a `SyntaxError` raised while PARSING a script: TEC-3747 was
 * 320 unattributable occurrences while `window.onerror` carried `filename`/`lineno` all along. Its own
 * field, never a frame, since `stack` fingerprints.
 */
/** Browsers report 0 for "unknown", and a `0` in a ticket reads like a position rather than a gap. */
function position(value: number | undefined): number | undefined {
	return typeof value === 'number' && Number.isInteger(value) && value > 0 ? value : undefined;
}

export function scriptErrorLocation(event: { filename?: string; lineno?: number; colno?: number }): string | undefined {
	const url = event.filename?.trim();
	// Empty on a cross-origin script: absent evidence, not an inline script, so no bare `:1:1`.
	if (!url) return undefined;

	const line = position(event.lineno);
	// A column with no line cannot be placed: never `url::34`.
	if (line === undefined) return url;

	const column = position(event.colno);
	return column === undefined ? `${url}:${line}` : `${url}:${line}:${column}`;
}
